import React from 'react';
import {Typography} from '@/components/Typography';
import {ButtonItem} from './StyledComponents';

interface IProps {
  icon?: string;
  label: string;
  active?: boolean;
  disabled?: boolean;
  onClick?(label?: string): void;
}

export const Menu = React.forwardRef<HTMLDivElement, IProps>(
  ({icon, label, active, disabled, onClick}, ref) => {
    return (
      <ButtonItem
        active={active}
        disabled={disabled}
        ref={ref}
        onClick={() => onClick?.(label)}
      >
        {!!icon?.length && (
          <img src={icon} width={24} height={24} alt={label} />
        )}
        <Typography variant="medium14">{label}</Typography>
      </ButtonItem>
    );
  }
);
